module.exports = __webpack_public_path__ + "img/lk_task.dd6ac8b4.svg";